import PropTypes from 'prop-types';

export const reviewResponseShape = PropTypes.shape({
  content: PropTypes.string,
  status: PropTypes.string,
  statusDisplay: PropTypes.string,
  submittedAt: PropTypes.string,
  publishAt: PropTypes.string,
});

export const reviewShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  localId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  author: PropTypes.string,
  text: PropTypes.string,
  source: PropTypes.string,
  rating: PropTypes.number,
  reviewDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  status: PropTypes.string,
  reviewResponse: reviewResponseShape,
});
